import {Service} from '../../service';

export class ConfigReportService extends Service {

  static entity = 'app/config';

  static get(reportName: string): Promise<any> {
    return this.axios.get(`${this.entity}/file-config-report?reportName=${reportName}`).then(res => res.data);
  }

  static set(reportName: string, items: Array<any>): Promise<any> {
    return this.axios.put(`${this.entity}/save-report-config`, {reportName, details: items}).then(res => res.data);
  }

  static restore(reportName: string): Promise<any> {
    return this.axios.get(`${this.entity}/revert-config-report?reportName=${reportName}`).then(res => res.data);
  }

}
